import { createSelector, createFeatureSelector } from '@ngrx/store';

import { Depreciation } from '@core/models/depreciation.interface';


export const selectDepreciationState = createFeatureSelector<Depreciation>('depreciation');


// Stepper
export const selectCurrentStepState = createSelector(
  selectDepreciationState,
  ({ currentStep }) => currentStep
);

// First step
export const selectFirstStepState = createSelector(
  selectDepreciationState,
  ({ firstStep }) => firstStep
);

export const selectSocketFirstStepState = createSelector(
  selectFirstStepState,
  ({ socket }) => socket
);

// Second step
export const selectSecondStepState = createSelector(
  selectDepreciationState,
  ({ secondStep }) => secondStep
);

// Third step
export const selectThirdStepState = createSelector(
  selectDepreciationState,
  ({ thirdStep }) => thirdStep
);

export const selectSocketThirdStepState = createSelector(
  selectThirdStepState,
  ({ socket }) => socket
);

// Skip events step
export const selectSkipEventsStepState = createSelector(
  selectDepreciationState,
  ({ skipEventsStep }) => skipEventsStep
);

// Fourth step
export const selectFourthStepState = createSelector(
  selectDepreciationState,
  ({ fourthStep }) => fourthStep
);

// Fifth step
export const selectFifthStepState = createSelector(
  selectDepreciationState,
  ({ fifthStep }) => fifthStep
);

// ID
export const selectDepreciationIDState = createSelector(
  selectDepreciationState,
  ({ id }) => id
);
